// @ts-nocheck
import { useCallback, useEffect, useState } from 'react';
import { useGet } from 'hooks';
import { Box } from '@mui/material';
import { FIELD_TYPES } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constant';
import VirtualizedAutoComplete from 'components/__v5__/MuiAutoComplete/VirtualizedAutoComplete';
import ActionMessage from './ActionMessage';

export const SelectPreview = ({
  field,
  tableId,
  tableType,
  rowIndex,
  colIndex,
  updatePreviewColumn,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const isMultipleSelect = field.type === FIELD_TYPES.MULTIPLESELECT;

  const [value, setValue] = useState([]);

  const [options, setOptions] = useState(
    field.choice
      .filter((item) => item.label)
      .map((item) => ({ id: item.id, label: item.label })),
  );

  if (!field.fromManualList) {
    useGet('v1.1/custom-form/get_linked_choices/', {
      query: { choice_id: field.islinked_query, page: 1, per_page: 10000 },
      onSuccess(data) {
        setOptions(data?.data || []);
      },
    });
  }

  const handleMultiSelectChange = (selectedValues) => {
    const values = selectedValues.map((selected) => selected.id).join(',');
    const labels = selectedValues.map((selected) => selected.label).join(',');

    updatePreviewColumn(tableId, rowIndex, colIndex, {
      answer: values,
      selectedLinkListLabel: labels,
    });

    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(tableId, values, tableType, labels, {
        rowIndex,
        colIndex,
        tableElementType: field?.type,
      });
    }
  };

  const handleSelectChange = (selectedValue) => {
    const value = {
      answer: selectedValue?.id,
      selectedLinkListLabel: selectedValue?.label,
    };
    updatePreviewColumn(tableId, rowIndex, colIndex, value);

    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(
        tableId,
        selectedValue?.id,
        tableType,
        selectedValue?.label,
        {
          rowIndex,
          colIndex,
          tableElementType: field?.type,
        },
      );
    }
  };

  const getSelectedAnswer = useCallback(() => {
    const answer = isMultipleSelect
      ? options.filter((option) => field.answer.includes(option.id))
      : options.find((option) => field.answer.includes(option.id));
    return answer;
  }, [isMultipleSelect, options, field]);

  useEffect(() => {
    if (field.answer && options.length > 0) {
      setValue(getSelectedAnswer());
    }
  }, [field.answer, getSelectedAnswer]);

  return (
    <Box
      sx={{
        '& .MuiAutocomplete-input.MuiInputBase-inputAdornedStart.MuiInputBase-inputAdornedEnd':
          {
            width: '0!important',
          },
      }}
    >
      <VirtualizedAutoComplete
        id="notify-to-autocomplete"
        optionData={options}
        value={value}
        placeholder={`Select ${field.islinked_query || 'Options'}`}
        datatestid="notify-to"
        setValue={
          isMultipleSelect ? handleMultiSelectChange : handleSelectChange
        }
        getOptionLabel={(option) => option.label || ''}
        multiple={isMultipleSelect}
        style={{ width: '100%' }}
        width={300}
        loading={false}
        getOptionGroup={null}
        disabled={shouldBeReadOnly}
      />
      <ActionMessage field={field} />
    </Box>
  );
};
